module.exports = {"330114001":"下沙街道","330114002":"白杨街道","330114003":"河庄街道","330114004":"义蓬街道","330114005":"新湾街道","330114006":"临江街道","330114007":"前进街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330114.json
// module id = 1052
// module chunks = 0